import newhttp from '~/http/new';

export default ({
  state: {
    data: [],
    page: 1,
    limit: 10,
    pages: 0,
  },

  mutations: {
    SET_PAGE(state, value) { state.page = value; },
    SET_PAGES(state, value) { state.pages = value; },
    SET_DATA(state, data) { state.data = data; },
    SET_ALL_DATA(state, data) { state.allData = data; },
  },

  getters: {
    requestData(state) {
      const {
        limit,
        page,
      } = state;
      return {
        offset: (page - 1) * limit,
        status: [10],
        limit,
      };
    },
  },

  actions: {
    setPage({ commit }, value) { commit('SET_PAGE', value); },
    setPages({ commit }, value) { commit('SET_PAGES', value); },

    async loadData({ state, commit, getters }, dataObj) {
      const { limit } = state;
      const response = await newhttp.get('v1/arbitrator/trades', {
        params: {
          ...getters.requestData,
          ...dataObj,
          status: [5, 6],
        },
      });
      const { data, total } = response.data;
      commit('SET_DATA', data);
      if (total) {
        const pages = Math.ceil(total / limit);
        commit('SET_PAGES', pages);
      }
    },
  },

  namespaced: true,
});
